import { GetGameById } from "@grassrootly/api";
import useBaseRequest from "../../api/BaseRequest";
import { useGame } from "../../api/game/GameSelector";
import { useAppDispatch } from "@grassrootly/rn-core";
import { gameActions } from "../../api/game/GameReducer";

export function useGameScreen(id: number) {
  const game = useGame(id);
  const dispatch = useAppDispatch();
  const { loading } = useBaseRequest(GetGameById, {
    initialPayload: {
      id,
    },
    autoFetch: true,
    onCompleted: (data) => {
      if (!data) return;
      dispatch(gameActions.setGame(data));
    },
  });

  return { loading, game };
}
